// @flow
import React from 'react';
import { useTheme } from '@material-ui/styles';
import Avatar from '@material-ui/core/Avatar';

import AvatarLogo from '../Icons/AvatarLogo';

interface Props {
  width?: number;
  height?: number;
  user: Object;
}

const UserAvatar = ({ width, height, user }: Props) => {
  const theme = useTheme();

  if (user?.userPhoto?.url) {
    return (
      <Avatar
        src={user.userPhoto.url}
        alt="profile_photo"
        style={{
          width: width || 40,
          height: height || 40,
        }}
      />
    );
  }

  return (
    <div>
      <AvatarLogo
        color={
          theme.palette.type === 'light'
            ? theme.palette.ava.navyGroup.convoText
            : theme.palette.ava.navyGroup.convoTextDark
        }
        width={width || 40}
        height={height || 40}
      />
    </div>
  );
};

export default UserAvatar;
